export function getavatar(val) {
    // console.log(val)
    if (val && val.indexOf("http") == -1) {
        if (val.indexOf("/avatar/") == -1) {
            return process.env.VUE_APP_URL + "/avatar/" + val;
        } else {
            return process.env.VUE_APP_URL + val.split("zlxadmin")[1];
        }
    } else {
        return val;
    }
}
